export default "__VITE_ASSET__D8H0t6wf__"